import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import * as _ from 'lodash';
import { browserHistory } from 'react-router';
import { populateComposebox } from 'redux/modules/composeboxForm';
import { enqueuePost } from 'redux/modules/contentLibrary';
import { connect } from 'react-redux';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';

var getUrls = require('get-urls');

var ContentPostActions = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    queues: state.queues[orgId] || [],
    categoryContent: state.contentLibraryContent.categoryContent,
    addingPostToQueue: state.contentLibrary.addingPostToQueue
  };
}, {
  enqueuePost: enqueuePost,
  populateComposebox: populateComposebox
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ContentPostActions, _Component);

  var _super = _createSuper(ContentPostActions);

  function ContentPostActions(props) {
    var _this;

    _classCallCheck(this, ContentPostActions);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getInitialValues", function () {
      var images = _this.props.post.S3Files && _this.props.post.S3Files.length ? [_this.props.post.S3Files[0].fullyQualifiedUrl] : null;
      var postType = 'textPost';
      var link = {}; // check to see if the post is from an RSS feed, in which case remove the image so the link will get parsed below

      if (images && typeof _this.props.post.S3Files[0].id === 'string' && _this.props.post.S3Files[0].id.includes('via_link')) {
        images = null;
      }

      if (!images) {
        if (_this.props.post.linkUrl) {
          link.link = _this.props.post.linkUrl;
          link.title = _this.props.post.linkTitle || _this.props.post.title;
          link.image = _this.props.post.linkImagePreview ? _this.props.post.linkImagePreview : null;
          postType = 'linkPost';
        } else {
          var urls = getUrls(_this.props.post.message);

          if (urls) {
            var l = Array.from(urls)[0];

            if (l) {
              link.link = l;
              link.title = _this.props.post.title;
              postType = 'linkPost';
            }
          }
        }
      } else {
        postType = 'imagePost';
      }

      var messagesData = {};
      _this.props.post.SocialAccountPostTemplates && _this.props.post.SocialAccountPostTemplates.length > 0 ? _this.props.post.SocialAccountPostTemplates.forEach(function (sapt) {
        messagesData[sapt.accountPlatform.toLowerCase()] = sapt.message;
      }) : null;
      return {
        messages: _objectSpread({
          global: _this.props.post.message
        }, messagesData),
        images: images,
        postType: postType,
        linkData: link
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleScheduleClick", function () {
      var translatedPost = _this.getInitialValues();

      _this.props.populateComposebox(translatedPost, _this.props.organization.id);

      browserHistory.push({
        pathname: "/org/".concat(_this.props.organization.id, "/compose"),
        state: {
          modal: false
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleAddPostToQueue", function () {
      _this.props.enqueuePost(_this.props.organization.id, _this.props.post.id, _this.state.selectedQueueId).then(function () {
        _this.setState({
          selectedQueueId: 1234567890
        });
      });
    });

    _this.state = {
      selectedQueueId: 1234567890
    };
    return _this;
  }

  _createClass(ContentPostActions, [{
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this2 = this;

      var post = this.props.post;
      var queueChoices = this.props.queues ? this.props.queues.map(function (q) {
        return {
          id: q.id,
          title: q.SocialAccounts[0].username,
          platform: q.type.toLowerCase().split(' ')[0]
        };
      }) : null;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '24px 32px'
        }
      }, queueChoices && /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/React.createElement(SelectField, {
        value: this.state.selectedQueueId,
        onChange: function onChange(event, index, value) {
          _this2.setState({
            selectedQueueId: value
          });
        }
      }, /*#__PURE__*/React.createElement(MenuItem, {
        value: 1234567890,
        primaryText: "Select A Queue"
      }), queueChoices.map(function (q) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: "queue_".concat(q.id),
          value: q.id,
          primaryText: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-".concat(q.platform),
            style: {
              marginRight: 8
            }
          }), /*#__PURE__*/React.createElement("span", null, q.title))
        });
      })), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Add To Queue",
        onClick: this.handleAddPostToQueue,
        disabled: this.state.selectedQueueId === 1234567890 || this.props.addingPostToQueue
      })), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Schedule Post",
        onClick: this.handleScheduleClick
      }));
    }
  }]);

  return ContentPostActions;
}(Component)) || _class);
export default ContentPostActions;